import {Injectable} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  roles: string[];

  constructor(private keycloakService: KeycloakService) {
    this.roles = this.keycloakService.getUserRoles();
  }

  isGestionnaire(): boolean {
    return this.roles.indexOf('gestionnaire') !== -1;
  }

  isReferent(): boolean {
    return this.roles.indexOf('Referent') !== -1;
  }

  isCollaborateur(): boolean {
    return this.roles.indexOf('collaborateur') !== -1;
  }

  hasProduct(): boolean {
    // Product is ALWAYS 2 letters, so we have to found out if we have at least one product role
    return this.roles.find(r => r.length === 2) !== undefined;
  }
}
